import React from 'react'
import { Field } from 'app/blocks/form'
import { RhfProps } from 'app/components/primitive/Form/RhfProps'
import { DatePickerRhf } from 'app/components/primitive/Form/DatePicker/DatePickerRhf'

export const Date: React.FC<Field & RhfProps<any>> = ({
  name,
  label,
  control,
  required: requiredFromProps,
}) => {
  return (
    <DatePickerRhf
      id={name}
      name={name}
      label={label}
      control={control}
      required={requiredFromProps}
      theme="form"
    />
  )
}
